

export interface ErrorResponse {
  detail: string;
}

export function getToken() {
  return localStorage.getItem('access_token');
}

export async function authorizedFetch(input: string, init?: RequestInit): Promise<Response> {
  const token = getToken();

  const headers = new Headers(init?.headers || {});
  headers.set('accept', 'application/json');
  
  // Define Content-Type como JSON apenas se não for FormData (upload de ficheiros)
  if (!(init?.body instanceof FormData)) {
    headers.set('Content-Type', 'application/json');
  }

  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  const response = await fetch(`${input}`, { ...init, headers });

  // Se receber 401 (Não autorizado), limpa o token e volta ao login
  if (response.status === 401) {
    localStorage.removeItem('access_token');
    window.location.href = '/login';
  }

  return response;
}